import { useEffect, useState, useCallback } from "react";
import { Navbar } from "@/components/Navbar";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { ThreadList } from "@/components/messages/ThreadList";
import { Conversation } from "@/components/messages/Conversation";
import { PageBackground } from "@/components/PageBackground";

export default function Messages() {
  const { user } = useAuth();
  const [threads, setThreads] = useState([]);
  const [active, setActive] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");

  const loadThreads = useCallback(async () => {
    const { data } = await api.get("/messages/threads");
    setThreads(data);
    if (!active && data.length) setActive(data[0]);
  }, [active]);

  useEffect(() => { loadThreads(); }, [loadThreads]);

  const loadMsgs = useCallback(async (partnerId) => {
    try {
      const { data } = await api.get(`/messages/${partnerId}`);
      setMsgs(data);
    } catch { setMsgs([]); }
  }, []);

  useEffect(() => { if (active) loadMsgs(active.partner_id); }, [active, loadMsgs]);

  const send = async () => {
    if (!text.trim() || !active) return;
    try {
      await api.post("/messages", { recipient_id: active.partner_id, text });
      setText("");
      loadMsgs(active.partner_id);
    } catch (err) { toast.error(err.response?.data?.detail || "Failed to send message"); }
  };

  return (
    <div>
      <PageBackground variant={1} />
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-8">
        <h1 className="font-display text-3xl font-semibold tracking-tight mb-6">Messages</h1>
        {threads.length === 0 ? (
          <div className="bg-white border border-border rounded-sm p-12 text-center text-muted-foreground">
            <MessageSquare className="w-10 h-10 mx-auto mb-3 opacity-40" />
            Messaging unlocks once an offer is sent or received.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 h-[70vh]">
            <ThreadList threads={threads} activeId={active?.partner_id} onSelect={setActive} />
            <Conversation msgs={msgs} userId={user.id} text={text} setText={setText} onSend={send} />
          </div>
        )}
      </div>
    </div>
  );
}
